/**
 * Checks whether the current user can access a given feature path.
 * Mirrors the sidebar's canAccessFeature logic — reads from localStorage.
 */
export const canAccessFeature = (path) => {
  try {
    const prefs = JSON.parse(localStorage.getItem('uiPreferences') || '{}');
    const role = localStorage.getItem('role');

    const isMgrOrEmp = role === 'manager' || role === 'employee';
    const isMgrOrAdmin = role === 'manager' || role === 'admin';

    const map = {
      '/students':               true,
      '/financial':              isMgrOrEmp && !!prefs?.financial?.financial_management,
      '/recipient':              isMgrOrEmp && !!prefs?.financial?.recipient_management,
      '/finance/cheques-status': isMgrOrEmp && !!prefs?.financial?.payments_schedule,
      '/finance/outgoingcheque': isMgrOrEmp && !!prefs?.financial?.outgoing_cheques,
      '/fee-management':         isMgrOrAdmin,
      '/staff':                  isMgrOrEmp && !!prefs?.school?.staff,
      '/classes':                !!prefs?.school?.classes,
      '/buses':                  isMgrOrEmp && !!prefs?.school?.buses,
      '/store':                  isMgrOrEmp && !!prefs?.school?.store,
      '/store-purchases':        isMgrOrEmp && !!prefs?.school?.store,
      '/miscellaneous':          isMgrOrEmp && !!(prefs?.school?.miscellaneous || prefs?.school?.store),
      '/authorized-payers':      isMgrOrEmp,
      '/library':                !!prefs?.school?.library,
      '/events':                 isMgrOrEmp || role === 'teacher',
      '/archivestudents':        isMgrOrEmp && !!prefs?.school?.archive,
      '/admin/users':            isMgrOrAdmin,
      '/admin/logs':             isMgrOrAdmin && !!prefs?.administrative?.logs,
      '/admin/year-transition':  isMgrOrAdmin,
      '/reports':                isMgrOrAdmin,
      '/settings':               isMgrOrAdmin && !!prefs?.administrative?.settings,
    };

    return !!map[path];
  } catch {
    return false;
  }
};
